/* 3dprintedmom chip-drop popup (Plinko-style, replaced the spin wheel 2026-10-08). Loaded by snippets/plinko.liquid.
   Retro daytime-gameshow look: sunburst, chasing marquee bulbs, a chip that slides across the top until the
   visitor hits DROP. The board is a show: wherever the chip is dropped it lands in the nearer of the two
   "20% OFF FILES" slots (3rd from either side, never the middle). The code is only revealed after the visitor
   subscribes via Shopify's newsletter (customer) form; the discount itself is limited to customers with no
   orders, one use each. Customer-facing copy deliberately avoids the TV show's name and the Plinko trademark.
   Shows once per browser, ever: marked seen the moment it opens. It shares the spin wheel's storage key,
   so anyone who already saw, won or claimed on the wheel keeps that state (and their pill).
   ?spin=1 / ?plinko=1 forces it open, ?spin=reset / ?plinko=reset clears it. */
(function () {
  var script = document.currentScript;
  if (!script || window.__plinko) return;
  window.__plinko = true;

  var CODE = script.dataset.code || 'SPIN20';
  var SHOP = script.dataset.shop || '/collections/digital-downloads';
  var CLAIM = '/discount/' + encodeURIComponent(CODE) + '?redirect=' + encodeURIComponent(SHOP);
  var KEY = '3dpm-spin-v1', SOUND_KEY = '3dpm-sound';
  var OPEN_DELAY = 1200;
  var DISPLAY = "'Luckiest Guy','Bungee',Impact,sans-serif", LABEL = "'Bungee',Impact,sans-serif";

  // Board geometry (SVG units). Columns 0..8 sit over the 9 bins. Each peg row moves the chip half a
  // column, so 12 rows from any top column can reach either winning bin.
  var VW = 348, VH = 432, X0 = 12, COL = 36, ROWS = 12, PEG_Y0 = 60, ROW_H = 23.5;
  var PEG_R = 3.6, CHIP_R = 10, CHIP_Y = 26, BIN_TOP = 338, FLOOR = 418, WIN_BINS = [2, 6];
  var BINS = [
    { t: 'FREE', s: 'SHIPPING',  bg: '#1FA2FF' },
    { t: '15%',  s: 'OFF',       bg: '#9B5DE5' },
    { t: '20%',  s: 'OFF FILES', bg: '#FF2E88' },
    { t: '$10',  s: 'OFF',       bg: '#06D6A0' },
    { t: 'FREE', s: 'GUIDE',     bg: '#FFD60A', fg: '#3A0CA3', star: true },
    { t: '$10',  s: 'OFF',       bg: '#06D6A0' },
    { t: '20%',  s: 'OFF FILES', bg: '#FF2E88' },
    { t: '15%',  s: 'OFF',       bg: '#9B5DE5' },
    { t: 'FREE', s: 'SHIPPING',  bg: '#1FA2FF' }
  ];

  function load() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
  function save(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }

  var params = new URLSearchParams(location.search);
  var flag = params.get('plinko') || params.get('spin');
  if (flag === 'reset') { try { localStorage.removeItem(KEY); } catch (e) {} }
  var forced = flag === '1';
  var state = forced ? null : load();
  var reopen = false;
  // Back from Shopify's bot challenge after a native newsletter submit: the signup went through.
  if (state && state.pending && params.get('customer_posted') === 'true') {
    state = { s: 'claimed', t: Date.now(), email: state.pending };
    save(state);
    reopen = true;
  }
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  var showPopup = !state && (forced || !script.dataset.guide);   // guide pages: wait for the next non-guide page
  var showPill = state && (state.s === 'won' || state.s === 'claimed') && !state.pillHidden;
  if (!showPopup && !showPill && !reopen) return;

  var fonts = document.createElement('link');
  fonts.rel = 'stylesheet';
  fonts.href = 'https://fonts.googleapis.com/css2?family=Bungee&family=Luckiest+Guy&display=swap';
  document.head.appendChild(fonts);

  var CSS = [
    '.pk-overlay{position:fixed;inset:0;z-index:1000;display:flex;align-items:center;justify-content:center;padding:1rem;background:rgba(20,6,50,.72);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);opacity:0;transition:opacity .25s ease}',
    '.pk-overlay[hidden]{display:none}',
    '.pk-overlay.is-open{opacity:1}',
    '.pk-card{position:relative;box-sizing:border-box;width:100%;max-width:26rem;max-height:calc(100dvh - 2rem);overflow-y:auto;overflow-x:hidden;border:6px solid #FFE66B;border-radius:1.75rem;box-shadow:0 0 0 5px #FF2E88,0 28px 70px rgba(0,0,0,.5);padding:1.2rem 1.1rem 1rem;text-align:center;color:#fff;font-family:system-ui,-apple-system,sans-serif;' +
      'background:radial-gradient(circle at 50% 16%,rgba(255,255,255,.4) 0,rgba(255,255,255,0) 20%,rgba(58,12,163,0) 38%,rgba(43,10,107,.92) 80%),repeating-conic-gradient(from 0deg at 50% 16%,#FF9F1C 0 7.5deg,#FFC93C 7.5deg 15deg);' +
      'transform:scale(.6) rotate(-6deg);transition:transform .55s cubic-bezier(.34,1.7,.5,1)}',
    '.pk-card *{box-sizing:border-box}',
    '.pk-overlay.is-open .pk-card{transform:none}',
    '.pk-x,.pk-mute{position:absolute;top:.55rem;z-index:2;display:flex;align-items:center;justify-content:center;width:2.3rem;height:2.3rem;border:3px solid #3A0CA3;border-radius:50%;background:#fff;color:#3A0CA3;line-height:1;cursor:pointer;box-shadow:0 3px 0 #3A0CA3}',
    '.pk-x{right:.55rem;font-size:1.45rem;font-weight:800}',
    '.pk-mute{left:.55rem;font-size:.95rem}',
    '.pk-eyebrow{display:inline-block;font-family:' + LABEL + ';font-size:.7rem;letter-spacing:.08em;background:#FF2E88;color:#fff;padding:.3rem .8rem;border-radius:999px;margin:.15rem 2.4rem 0;white-space:nowrap;box-shadow:0 3px 0 #9C0050}',
    '.pk-title{font-family:' + DISPLAY + ';font-weight:400;font-size:2.7rem;line-height:1;color:#FFE66B;margin:.5rem 0 .55rem;text-shadow:3px 3px 0 #FF2E88,6px 6px 0 #3A0CA3;transform:rotate(-2deg);letter-spacing:.02em}',
    '.pk-sub{display:inline-block;background:#3A0CA3;color:#fff;font-weight:800;font-size:.86rem;line-height:1.35;padding:.4rem .95rem;border-radius:999px;margin:0;max-width:21rem;box-shadow:0 3px 0 #22075F}',
    '.pk-card :focus-visible{outline:3px solid #fff;outline-offset:2px}',
    '.pk-board{display:block;width:min(21rem,84vw,calc(50dvh * .806));margin:.9rem auto .7rem;padding:0;border:0;background:none;cursor:pointer;transition:width .45s ease}',
    '.pk-board:disabled{cursor:default}',
    '.pk-board svg{display:block;width:100%;height:auto;filter:drop-shadow(0 8px 0 rgba(43,10,107,.6))}',
    '.pk-board text{font-family:' + LABEL + ';text-anchor:middle;pointer-events:none;paint-order:stroke;stroke-linejoin:round}',
    '.pk-peg{transform-box:fill-box;transform-origin:center}',
    '.pk-peg.is-hit{fill:#FFE66B}',
    '.pk-bulb{animation:pk-blink 1s infinite}',
    '.pk-bulb.b1{animation-delay:-.5s}',
    '@keyframes pk-blink{0%,49%{fill:#FFF8C2}50%,100%{fill:#A87400}}',
    '.pk-board.is-won .pk-bulb{animation-duration:.24s}',
    '.pk-win rect{animation:pk-glow .3s steps(1) 10}',
    '@keyframes pk-glow{50%{fill:#FFE66B}}',
    '.pk-actions{display:flex;flex-direction:column;align-items:center;gap:.45rem}',
    '.pk-actions[hidden],.pk-result[hidden]{display:none}',
    '.pk-btn{display:inline-flex;align-items:center;justify-content:center;border:4px solid #FFE66B;border-radius:999px;background:linear-gradient(#FF5A5A,#D90429);color:#fff;font-family:' + LABEL + ';font-size:1.05rem;letter-spacing:.04em;padding:.75rem 1.4rem;cursor:pointer;text-decoration:none;box-shadow:0 6px 0 #7A0016,0 12px 22px rgba(0,0,0,.35);text-shadow:0 2px 0 rgba(0,0,0,.25);transition:transform .08s,box-shadow .08s}',
    '.pk-btn:active{transform:translateY(4px);box-shadow:0 2px 0 #7A0016,0 6px 12px rgba(0,0,0,.3)}',
    '.pk-go{min-width:12rem;font-size:1.75rem;padding:.55rem 2.2rem;animation:pk-pulse 1.1s ease-in-out infinite}',
    '.pk-go:disabled{animation:none;opacity:.75;cursor:default}',
    '@keyframes pk-pulse{50%{transform:scale(1.07)}}',
    '.pk-alt{background:linear-gradient(#FFF27A,#FFC300);color:#2B0A6B;border-color:#3A0CA3;box-shadow:0 5px 0 #2B0A6B;text-shadow:none}',
    '.pk-alt:active{box-shadow:0 1px 0 #2B0A6B}',
    '.pk-no{border:0;background:none;color:#fff;font-family:inherit;font-weight:800;font-size:.85rem;padding:.35rem .75rem;cursor:pointer;text-decoration:underline;text-underline-offset:3px;text-shadow:0 1px 0 #3A0CA3}',
    '.pk-result{animation:pk-in .45s cubic-bezier(.34,1.56,.64,1)}',
    '@keyframes pk-in{from{opacity:0;transform:translateY(14px) scale(.95)}}',
    '.pk-winner{font-family:' + DISPLAY + ';font-weight:400;font-size:2.7rem;line-height:1;color:#FFE66B;margin:0;text-shadow:3px 3px 0 #FF2E88,6px 6px 0 #3A0CA3;transform:rotate(-2deg);animation:pk-flash .4s steps(1) 7}',
    '@keyframes pk-flash{50%{color:#fff}}',
    '.pk-won{font-family:' + LABEL + ';font-size:1rem;line-height:1.25;color:#fff;text-shadow:0 2px 0 #3A0CA3;margin:.5rem 0 .7rem}',
    '.pk-won b{color:#FFE66B;font-weight:400}',
    '.pk-panel{background:#fff;color:#2B0A6B;border:4px solid #3A0CA3;border-radius:1.25rem;box-shadow:0 6px 0 #2B0A6B;padding:.9rem .9rem 1rem}',
    '.pk-won-sub{font-size:.9rem;font-weight:700;line-height:1.4;color:#4A3A78;margin:0 auto .75rem;max-width:20rem;text-wrap:balance}',
    '.pk-code{display:flex;align-items:center;justify-content:center;gap:.7rem;margin:.1rem 0 .9rem}',
    '.pk-tag{position:relative;display:inline-block;background:#FFE66B;color:#2B0A6B;font-family:' + LABEL + ';font-size:1.45rem;letter-spacing:.06em;padding:.45rem 1rem .45rem 1.9rem;clip-path:polygon(18px 0,100% 0,100% 100%,18px 100%,0 50%);border-radius:0 .5rem .5rem 0;transform:rotate(-3deg)}',
    '.pk-tag:before{content:"";position:absolute;left:12px;top:50%;width:9px;height:9px;margin-top:-4.5px;border-radius:50%;background:#fff;box-shadow:inset 0 0 0 2px #2B0A6B}',
    '.pk-copy{border:0;border-radius:999px;background:#3A0CA3;color:#fff;font-family:' + LABEL + ';font-size:.78rem;padding:.55rem .9rem;cursor:pointer;box-shadow:0 3px 0 #22075F}',
    '.pk-claim{display:flex;width:100%;max-width:17rem;margin:0 auto}',
    '.pk-step-email[hidden],.pk-step-code[hidden],.pk-err[hidden]{display:none}',
    '.pk-form{display:flex;flex-direction:column;gap:.55rem;max-width:18rem;margin:0 auto}',
    '.pk-input{width:100%;border:3px solid #3A0CA3;border-radius:999px;background:#fff;padding:.7rem 1.1rem;font-family:inherit;font-size:1rem;font-weight:700;color:#2B0A6B;text-align:center;outline:0}',
    '.pk-input:focus{border-color:#FF2E88;box-shadow:0 0 0 3px rgba(255,46,136,.25)}',
    '.pk-sub-btn{width:100%}',
    '.pk-err{color:#D90429;font-size:.85rem;font-weight:700;margin:0}',
    '.pk-fine{font-size:.72rem;color:#6B5A96;margin:.6rem auto 0;max-width:18rem;line-height:1.4}',
    '.pk-sr{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}',
    '.pk-note{font-size:.78rem;color:#6B5A96;margin:.55rem 0 0}',
    '.pk-terms{margin-top:.8rem;font-size:.72rem;color:#fff;font-weight:700}',
    '.pk-terms summary{cursor:pointer;display:inline-block;text-decoration:underline;text-underline-offset:2px;text-shadow:0 1px 0 #3A0CA3}',
    '.pk-terms p{margin:.45rem 0 0;text-align:left;line-height:1.45;font-weight:600;background:rgba(43,10,107,.88);padding:.6rem .75rem;border-radius:.75rem}',
    '.pk-confetti{position:fixed;top:0;left:0;width:9px;height:14px;border-radius:2px;z-index:1001;pointer-events:none}',
    '.pk-pill{position:fixed;left:1rem;bottom:1rem;z-index:45;display:flex;align-items:center;border:3px solid #FFE66B;border-radius:999px;background:#3A0CA3;color:#FFE66B;box-shadow:0 0 0 3px #FF2E88,0 10px 30px rgba(0,0,0,.3);font-family:' + LABEL + ';letter-spacing:.03em;animation:pk-in .45s cubic-bezier(.34,1.56,.64,1)}',
    '.pk-pill button{border:0;background:none;color:inherit;font:inherit;cursor:pointer}',
    '.pk-pill-open{padding:.6rem .4rem .6rem 1rem;font-size:.8rem}',
    '.pk-pill-x{padding:.6rem .9rem .6rem .5rem;font-size:1.1rem;color:#fff !important}',
    '.pk-card.is-won .pk-board{width:min(15rem,62vw,calc(30dvh * .806));margin:.6rem auto}',
    '@media(max-width:480px){.pk-title,.pk-winner{font-size:2.3rem}.pk-pill{left:.75rem;bottom:.75rem}}',
    '@media(max-height:740px){.pk-title{font-size:2.1rem;margin:.35rem 0 .4rem}.pk-card.is-won .pk-board{width:min(11rem,46vw,calc(24dvh * .806));margin:.4rem auto}}',
    '@media(prefers-reduced-motion:reduce){.pk-bulb,.pk-go,.pk-winner,.pk-win rect{animation:none}}'
  ].join('');

  function colX(c) { return X0 + (c + 0.5) * COL; }
  function pegY(row) { return PEG_Y0 + row * ROW_H; }

  function boardSvg() {
    var out = '<svg viewBox="0 0 ' + VW + ' ' + VH + '" aria-hidden="true"><defs>' +
      '<linearGradient id="pkFace" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#2440B8"/><stop offset="1" stop-color="#0B1454"/></linearGradient>' +
      '<radialGradient id="pkPeg" cx=".35" cy=".35" r=".7"><stop offset="0" stop-color="#fff"/><stop offset="1" stop-color="#8E9BB5"/></radialGradient>' +
      '<radialGradient id="pkChip" cx=".35" cy=".3" r=".8"><stop offset="0" stop-color="#FF7A7A"/><stop offset="1" stop-color="#C1121F"/></radialGradient>' +
      '</defs>' +
      '<rect x="6" y="6" width="' + (VW - 12) + '" height="' + (VH - 12) + '" rx="18" fill="url(#pkFace)" stroke="#F5B700" stroke-width="10"/>';
    // Bins: 9 coloured pockets with vertical prize labels, mirrored like the TV board.
    BINS.forEach(function (b, k) {
      var x = colX(k), cy = (BIN_TOP + FLOOR) / 2 + 2, fg = b.fg || '#fff', st = b.fg ? 'none' : '#2B0A6B';
      out += '<g class="pk-bin" data-k="' + k + '">' +
        '<rect x="' + (x - COL / 2 + 2) + '" y="' + BIN_TOP + '" width="' + (COL - 4) + '" height="' + (FLOOR - BIN_TOP) + '" rx="5" fill="' + b.bg + '"/>' +
        '<g transform="translate(' + x + ' ' + cy + ') rotate(-90)">' +
          '<text x="0" y="-1" font-size="15" fill="' + fg + '" stroke="' + st + '" stroke-width="3">' + b.t + '</text>' +
          '<text x="0" y="11" font-size="8.5" fill="' + fg + '" stroke="' + st + '" stroke-width="2.4">' + b.s + '</text>' +
        '</g>' +
        (b.star ? '<text x="' + x + '" y="' + (BIN_TOP + 13) + '" font-size="11" fill="#FF2E88">★</text>' : '') +
        '</g>';
    });
    for (var d = 0; d <= BINS.length; d++) {
      var dx = X0 + d * COL;
      out += '<rect x="' + (dx - 2) + '" y="' + (BIN_TOP - 10) + '" width="4" height="' + (FLOOR - BIN_TOP + 10) + '" rx="2" fill="#D9DEE8"/>';
    }
    // Hex peg grid: integer columns on even rows, half columns on odd rows.
    for (var r = 0; r < ROWS; r++) {
      for (var c = (r % 2) / 2; c <= 8; c += 1) {
        out += '<circle class="pk-peg" data-p="' + r + '_' + c + '" cx="' + colX(c) + '" cy="' + pegY(r) + '" r="' + PEG_R + '" fill="url(#pkPeg)"/>';
      }
    }
    // Marquee bulbs around the frame, alternating so they chase.
    var n = 0, bulb = function (x, y) { out += '<circle class="pk-bulb b' + (n++ % 2) + '" cx="' + x.toFixed(1) + '" cy="' + y.toFixed(1) + '" r="3.1" fill="#FFF8C2"/>'; };
    for (var bx = 24; bx <= VW - 24; bx += 18.75) bulb(bx, 6);
    for (var by = 26; by <= VH - 26; by += 19) bulb(VW - 6, by);
    for (bx = VW - 24; bx >= 24; bx -= 18.75) bulb(bx, VH - 6);
    for (by = VH - 26; by >= 26; by -= 19) bulb(6, by);
    out += '<g class="pk-chip"><circle r="' + CHIP_R + '" fill="url(#pkChip)" stroke="#fff" stroke-width="2"/>' +
      '<circle r="6" fill="none" stroke="#fff" stroke-width="1" stroke-dasharray="2 2" opacity=".8"/>' +
      '<text y="3.6" font-size="10" fill="#FFE66B" stroke="none">★</text></g>';
    return out + '</svg>';
  }

  var style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  var overlay, card, board, chipEl, goBtn, muteBtn, actions, result, lastFocus;
  var dropping = false, won = false, idleRaf = 0, chipCol = 4, manual = false, winBin = 2;

  function setChip(x, y) { chipEl.setAttribute('transform', 'translate(' + x.toFixed(2) + ' ' + y.toFixed(2) + ')'); }

  // ---- Sound: tiny WebAudio blips, only ever started from the DROP click. ----
  var actx = null;
  function soundOn() { try { return localStorage.getItem(SOUND_KEY) !== 'off'; } catch (e) { return true; } }
  function tone(freq, at, dur, type, vol) {
    if (!actx || !soundOn()) return;
    var t = actx.currentTime + at, o = actx.createOscillator(), g = actx.createGain();
    o.type = type; o.frequency.value = freq;
    g.gain.setValueAtTime(vol, t);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    o.connect(g); g.connect(actx.destination);
    o.start(t); o.stop(t + dur + 0.03);
  }
  function tick() { tone(1300 + Math.random() * 700, 0, 0.05, 'triangle', 0.07); }
  function fanfare() {
    [523, 659, 784, 1047].forEach(function (f, i) { tone(f, i * 0.11, 0.2, 'square', 0.05); });
    tone(1047, 0.44, 0.55, 'square', 0.05);
    [0.95, 1.2, 1.45].forEach(function (at) { tone(1568, at, 0.35, 'sine', 0.14); tone(2093, at, 0.25, 'sine', 0.05); });
  }
  function toggleSound() {
    var on = !soundOn();
    try { localStorage.setItem(SOUND_KEY, on ? 'on' : 'off'); } catch (e) {}
    muteBtn.textContent = on ? '🔊' : '🔇';
    muteBtn.setAttribute('aria-label', on ? 'Mute sound' : 'Turn sound on');
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'pk-overlay';
    overlay.hidden = true;
    var on = soundOn();
    overlay.innerHTML =
      '<div class="pk-card" role="dialog" aria-modal="true" aria-labelledby="pk-title">' +
        '<button type="button" class="pk-mute" aria-label="' + (on ? 'Mute sound' : 'Turn sound on') + '">' + (on ? '🔊' : '🔇') + '</button>' +
        '<button type="button" class="pk-x" aria-label="Close">&times;</button>' +
        '<p class="pk-eyebrow">★ TODAY’S BIG GAME ★</p>' +
        '<h2 id="pk-title" class="pk-title">DROP THE CHIP!</h2>' +
        '<p class="pk-sub">Every chip wins a prize! Watch it slide, then hit DROP.</p>' +
        '<button type="button" class="pk-board" aria-label="Drop the chip">' + boardSvg() + '</button>' +
        '<div class="pk-actions">' +
          '<button type="button" class="pk-btn pk-go">DROP!</button>' +
          '<button type="button" class="pk-no">No thanks, I’ll pass</button>' +
        '</div>' +
        '<div class="pk-result" hidden aria-live="polite">' +
          '<p class="pk-winner">WINNER!</p>' +
          '<p class="pk-won">You won <b>20% OFF</b> print files!</p>' +
          '<div class="pk-panel">' +
            '<div class="pk-step-email">' +
              '<p class="pk-won-sub">Subscribe to our emails to unlock your code. It&rsquo;s good on your first order of 3D print files.</p>' +
              '<form class="pk-form" method="post" action="/contact#plinko" accept-charset="UTF-8" novalidate>' +
                '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓">' +
                '<input type="hidden" name="contact[tags]" value="newsletter,spin-wheel,plinko">' +
                '<label class="pk-sr" for="pk-email">Email</label>' +
                '<input id="pk-email" class="pk-input" type="email" name="contact[email]" placeholder="you@example.com" autocomplete="email" required>' +
                '<button type="submit" class="pk-btn pk-alt pk-sub-btn">CLAIM MY PRIZE</button>' +
                '<p class="pk-err" role="alert" hidden></p>' +
              '</form>' +
              '<p class="pk-fine">By subscribing you&rsquo;ll get 3dprintedmom emails with new prints and offers. Unsubscribe anytime.</p>' +
            '</div>' +
            '<div class="pk-step-code" hidden>' +
              '<p class="pk-won-sub">You&rsquo;re subscribed! Check out with <b class="pk-email-echo"></b> so your code works (the guides aren&rsquo;t included).</p>' +
              '<div class="pk-code"><span class="pk-tag">' + CODE + '</span><button type="button" class="pk-copy">COPY</button></div>' +
              '<a class="pk-btn pk-claim" href="' + CLAIM + '">SHOP PRINT FILES &rarr;</a>' +
              '<p class="pk-note">We&rsquo;ll pop the code into your basket for you.</p>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<details class="pk-terms"><summary>Terms</summary><p>One drop per visitor. Every drop wins 20% off 3D print files (digital downloads) on your first order. ' +
          'To get the code, subscribe to 3dprintedmom emails. Code ' + CODE + ' only works at checkout with an email that has never ordered before. One use per email. ' +
          'Excludes the Before You Press Print and Press Print &amp; Walk Away guides. No cash value. ' +
          'The other prizes shown on the board are for display and are not awarded.</p></details>' +
      '</div>';
    document.body.appendChild(overlay);
    card = overlay.querySelector('.pk-card');
    board = overlay.querySelector('.pk-board');
    chipEl = overlay.querySelector('.pk-chip');
    goBtn = overlay.querySelector('.pk-go');
    muteBtn = overlay.querySelector('.pk-mute');
    actions = overlay.querySelector('.pk-actions');
    result = overlay.querySelector('.pk-result');
    setChip(colX(chipCol), CHIP_Y);

    overlay.querySelector('.pk-x').addEventListener('click', close);
    overlay.querySelector('.pk-no').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    muteBtn.addEventListener('click', toggleSound);
    board.addEventListener('click', drop);
    goBtn.addEventListener('click', drop);
    overlay.querySelector('.pk-copy').addEventListener('click', copyCode);
    overlay.querySelector('.pk-form').addEventListener('submit', subscribe);
    overlay.addEventListener('keydown', onKey);
  }

  function open(asWinner) {
    if (!overlay) build();
    if (asWinner) showResult(true);
    if (!won && !load()) save({ s: 'seen', t: Date.now() });   // leaving mid-popup still counts as the one showing
    lastFocus = document.activeElement;
    document.documentElement.style.overflow = 'hidden';
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    if (asWinner) focusStep(); else goBtn.focus({ preventScroll: true });
    if (!asWinner && !won) idle();
  }

  function close() {
    cancelAnimationFrame(idleRaf);
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { overlay.hidden = true; }, 250);
    if (won || dropping) pill(); else save({ s: 'closed', t: Date.now() });
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  function onKey(e) {
    if (e.key === 'Escape') { close(); return; }
    // Arrow keys aim the chip by hand (and stop the auto-slide).
    if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && !dropping && !won && e.target.tagName !== 'INPUT') {
      e.preventDefault();
      manual = true;
      chipCol = Math.max(0, Math.min(8, Math.round(chipCol) + (e.key === 'ArrowLeft' ? -1 : 1)));
      setChip(colX(chipCol), CHIP_Y);
      return;
    }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(card.querySelectorAll('button,a[href],summary,input'), function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }

  // Until it's dropped, the chip glides back and forth across the top like a contestant lining up.
  function idle() {
    if (reduce) return;
    var t0 = performance.now(), base = chipCol;
    (function frame(now) {
      if (!manual) {
        var p = (base + (now - t0) / 300) % 16;
        chipCol = p <= 8 ? p : 16 - p;
      }
      setChip(colX(chipCol), CHIP_Y + Math.sin((now - t0) / 200) * 1.5);
      idleRaf = requestAnimationFrame(frame);
    })(t0);
  }

  // Random half-column steps that stay on the board and can always still reach the target bin.
  function path(start, target) {
    var moves = [], x = start;
    for (var i = 0; i < ROWS; i++) {
      var left = ROWS - i - 1;
      var opts = [-0.5, 0.5].filter(function (d) {
        var nx = x + d;
        return nx >= 0 && nx <= 8 && Math.abs(target - nx) <= left * 0.5 + 1e-9;
      });
      var d = opts[Math.floor(Math.random() * opts.length)];
      moves.push(d); x += d;
    }
    return moves;
  }

  function hitPeg(row, c) {
    var peg = board.querySelector('[data-p="' + row + '_' + c + '"]');
    tick();
    if (!peg) return;
    peg.classList.add('is-hit');
    if (peg.animate) peg.animate([{ transform: 'scale(1.8)' }, { transform: 'scale(1)' }], { duration: 260, easing: 'ease-out' });
    setTimeout(function () { peg.classList.remove('is-hit'); }, 300);
  }

  // Each hop: a short upward kick off the peg, then gravity. y(t) = y0 - kick*t + (dy + kick)*t^2.
  function hop(from, to, kick, dur, done) {
    var start = performance.now();
    (function frame(now) {
      var t = Math.min(1, (now - start) / dur);
      setChip(from.x + (to.x - from.x) * t, from.y - kick * t + (to.y - from.y + kick) * t * t);
      if (t < 1) requestAnimationFrame(frame); else done();
    })(start);
  }

  function drop() {
    if (dropping || won) return;
    dropping = true;
    cancelAnimationFrame(idleRaf);
    board.disabled = goBtn.disabled = true;
    if (!actx) { try { actx = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) {} }
    if (actx && actx.state === 'suspended') actx.resume();

    var startCol = Math.round(chipCol);
    winBin = startCol < 4 ? 2 : startCol > 4 ? 6 : WIN_BINS[Math.floor(Math.random() * 2)];
    save({ s: 'won', t: Date.now() });   // outcome is fixed, so a close mid-drop still earns the pill

    var moves = path(startCol, winBin), speed = reduce ? 0.45 : 1;
    var col = startCol, row = 0, pos = { x: colX(chipCol), y: CHIP_Y };

    (function next() {
      if (row === ROWS) {   // last bounce into the pocket, then two little settles
        var rest = { x: colX(col), y: FLOOR - CHIP_R - 2 };
        hop(pos, rest, 6, 400 * speed, function () {
          tone(220, 0, 0.12, 'sine', 0.12);
          hop(rest, rest, reduce ? 0 : 12, 240 * speed, function () {
            hop(rest, rest, reduce ? 0 : 4, 150 * speed, function () { setTimeout(land, 150); });
          });
        });
        return;
      }
      // The chip rests on top of each peg it hits; the next is half a column over, one row down.
      var target = { x: colX(col), y: pegY(row) - PEG_R - CHIP_R };
      hop(pos, target, row === 0 ? 0 : 8, (row === 0 ? 300 : 190 + Math.random() * 60) * speed, function () {
        hitPeg(row, col);
        pos = target;
        col += moves[row];
        row++;
        next();
      });
    })();
  }

  function land() {
    dropping = false;
    won = true;
    board.classList.add('is-won');
    board.querySelector('[data-k="' + winBin + '"]').classList.add('pk-win');
    fanfare();
    if (!reduce && !overlay.hidden) confetti();
    setTimeout(function () { showResult(false); }, reduce ? 0 : 700);
  }

  function showResult(instant) {
    won = true;
    if (instant) {
      setChip(colX(winBin), FLOOR - CHIP_R - 2);
      board.classList.add('is-won');
      board.querySelector('[data-k="' + winBin + '"]').classList.add('pk-win');
      board.disabled = goBtn.disabled = true;
    }
    actions.hidden = true;
    card.classList.add('is-won');
    result.hidden = false;
    renderStep();
    if (!instant && !overlay.hidden) focusStep();
  }

  function claimedState() { var s = load(); return s && s.s === 'claimed' ? s : null; }

  function renderStep() {
    var c = claimedState();
    result.querySelector('.pk-step-email').hidden = !!c;
    result.querySelector('.pk-step-code').hidden = !c;
    if (c) result.querySelector('.pk-email-echo').textContent = c.email || 'the email you subscribed with';
  }

  // Touch screens skip auto-focusing the email box so the keyboard doesn't cover the win.
  function focusStep() {
    if (claimedState()) result.querySelector('.pk-claim').focus({ preventScroll: true });
    else if (matchMedia('(pointer: fine)').matches) result.querySelector('.pk-input').focus({ preventScroll: true });
  }

  // Newsletter signup through Shopify's built-in customer form. It must be a real form
  // submission: Shopify's captcha bootstrap intercepts submit events on /contact customer
  // forms, adds its token, then posts and returns here with ?customer_posted=true.
  function subscribe(e) {
    var form = e.currentTarget, input = form.querySelector('.pk-input');
    var btn = form.querySelector('.pk-sub-btn'), err = form.querySelector('.pk-err');
    var email = input.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      e.preventDefault();
      err.textContent = 'Please enter a valid email address.'; err.hidden = false;
      input.focus();
      return;
    }
    input.value = email;
    err.hidden = true;
    var s = load() || { s: 'won', t: Date.now() };
    s.pending = email; save(s);
    btn.textContent = 'CLAIMING…';
  }

  function confetti() {
    var bin = board.querySelector('[data-k="' + winBin + '"]').getBoundingClientRect();
    var cx = bin.left + bin.width / 2, cy = bin.top + bin.height / 3;
    var colors = ['#FF2E88', '#FFE66B', '#1FA2FF', '#06D6A0', '#9B5DE5', '#FF9F1C', '#fff'];
    for (var i = 0; i < 90; i++) {
      var p = document.createElement('i');
      p.className = 'pk-confetti';
      p.style.background = colors[i % colors.length];
      document.body.appendChild(p);
      var ang = -Math.PI / 2 + (Math.random() - 0.5) * Math.PI * 1.4, dist = 160 + Math.random() * 260;
      var x = Math.cos(ang) * dist, y = Math.sin(ang) * dist;
      var turn = (Math.random() * 720 - 360) + 'deg';
      p.animate([
        { transform: 'translate(' + cx + 'px,' + cy + 'px) rotate(0) scale(.6)', opacity: 1 },
        { transform: 'translate(' + (cx + x) + 'px,' + (cy + y) + 'px) rotate(' + turn + ') scale(1)', opacity: 1, offset: .55 },
        { transform: 'translate(' + (cx + x * 1.15) + 'px,' + (cy + y + 320) + 'px) rotate(' + turn + ') scale(1)', opacity: 0 }
      ], { duration: 1700 + Math.random() * 1000, easing: 'cubic-bezier(.2,.7,.4,1)', fill: 'forwards' })
        .onfinish = p.remove.bind(p);
    }
  }

  function copyCode() {
    var btn = overlay.querySelector('.pk-copy');
    function done() { btn.textContent = 'COPIED!'; setTimeout(function () { btn.textContent = 'COPY'; }, 1800); }
    function fallback() {
      var inp = document.createElement('input');
      inp.value = CODE; document.body.appendChild(inp); inp.select();
      try { document.execCommand('copy'); } catch (e) {}
      inp.remove(); done();
    }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(CODE).then(done, fallback);
    else fallback();
  }

  // After a win, a small corner reminder follows the visitor around the site.
  function pill() {
    if (document.querySelector('.pk-pill')) return;
    var s = load() || { s: 'won', t: Date.now() };
    if (s.pillHidden) return;
    var el = document.createElement('div');
    el.className = 'pk-pill';
    el.innerHTML = '<button type="button" class="pk-pill-open">' +
      (s.s === 'claimed' ? '★ 20% OFF FILES: ' + CODE : '★ CLAIM YOUR 20% OFF') + '</button>' +
      '<button type="button" class="pk-pill-x" aria-label="Hide discount reminder">&times;</button>';
    document.body.appendChild(el);
    el.querySelector('.pk-pill-open').addEventListener('click', function () { el.remove(); open(true); });
    el.querySelector('.pk-pill-x').addEventListener('click', function () {
      s.pillHidden = true; save(s); el.remove();
    });
  }

  function start() {
    if (reopen) open(true);
    else if (showPill) pill();
    else setTimeout(function () { open(false); }, forced ? 300 : OPEN_DELAY);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
